var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedicine10SvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.00 512.00",
    xmlSpace: "preserve",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: 0.00512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 2.048
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#ffffff;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M471.786,276.239L234.34,41.502l0.064,0.068C207.64,14.794,172.399,1.333,137.313,1.357 c-35.086-0.023-70.33,13.437-97.096,40.214C13.434,68.346-0.018,103.58,0,138.669c-0.018,35.09,13.434,70.331,40.218,97.1 l237.439,234.73l-0.064-0.068c26.772,26.776,62.006,40.228,97.092,40.214c35.09,0.014,70.323-13.438,97.095-40.207 c26.784-26.784,40.236-62.032,40.221-97.114C512.016,338.241,498.567,303.008,471.786,276.239z M79.604,178.202 c-22.745-22.74-22.745-60.226,0.287-83.254c11.151-11.155,25.982-17.292,41.763-17.292L79.604,178.202z M448.653,447.311 c-20.466,20.45-47.14,30.615-73.969,30.623c-26.826-0.008-53.504-10.173-73.973-30.631l-0.053-0.052l-0.007-0.016L191.244,339.079 c0.321-2.108,0.805-4.58,1.504-7.323c2.532-10.134,7.629-23.783,15.319-38.219c11.522-21.69,28.881-45.208,51.826-63.339 c22.838-18.017,50.855-30.896,85.582-32.846l103.137,101.958l0.049,0.038c20.45,20.473,30.615,47.144,30.638,73.973 C479.276,400.152,469.119,426.83,448.653,447.311z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicine10SvgrepoCom);
export default __webpack_public_path__ + "static/media/medicine-10-svgrepo-com.85d711263fde28941ef2c78f4a195730.svg";
export { ForwardRef as ReactComponent };